import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import classNames from 'classnames';
import { ButtonGroup } from '@george-labs.com/design-system';

import { getFeatureConfig } from '@luna/feature-config';
import _ from '@luna/lodash';

import { EnvironmentSwitchButton } from './EnvironmentSwitchButton';
import { groupEnvironments } from './EnvironmentSwitchButtonGroupService';
import styles from './EnvironmentSwitchButtonGroup.module.scss';

export const EnvironmentSwitchButtonGroup: FunctionComponent = () => {
    const environmentGroups = useMemo(() => {
        const { availableEnvironments } = getFeatureConfig(({ devTools }) => devTools);
        return groupEnvironments(availableEnvironments);
    }, []);

    const areApiTargetsAvailable = useMemo(
        () => !_.isEmpty(getFeatureConfig((config) => config.devTools.availableApiTargets)),
        [],
    );

    const className = classNames('px-2', 'm-0', {
        [styles.splitButtonGroup]: areApiTargetsAvailable,
    });

    return (
        <>
            {environmentGroups.map((environmentGroup) => (
                <ButtonGroup key={environmentGroup[0][0]} segmented className={className}>
                    {environmentGroup.map(([name, origin]) => (
                        <EnvironmentSwitchButton key={name} name={name} origin={origin} />
                    ))}
                </ButtonGroup>
            ))}
        </>
    );
};
